import { PoliciesState } from './ducks';

const getRootPoliciesState = (state): PoliciesState => state.policies;

export const getPolicies = state => getRootPoliciesState(state).policies;
export const getPoliciesLoading = state => getRootPoliciesState(state).loading;
